import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'

import { intlShape } from '@/checkout-instore-legacy/i18n/intlShape'
import { INSTORE_MAIN_URL } from '../constants'

import ErrorInfo from './ErrorInfo'

const ErrorBoundaryInfo = ({ error, intl, errorId }) => (
  <ErrorInfo
    title={intl.formatMessage({
      id: 'internalJsError',
    })}
    message={`${intl.formatMessage({
      id: 'contactSupportError',
    })}: ${error.message || error.toString()}, ${errorId}`}
    retry={() => window.location.reload()}
    giveUpText={`${intl.formatMessage({
      id: 'giveUpErrorBtnText',
    })}`}
    giveUp={() => (window.location.href = INSTORE_MAIN_URL)}
  />
)

ErrorBoundaryInfo.propTypes = {
  error: PropTypes.object.isRequired,
  intl: intlShape.isRequired,
  errorId: PropTypes.string,
}

export default injectIntl(ErrorBoundaryInfo)
